<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Manufacturing Cost Code"
                  v-model="manufacturingCost.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Manufacturing Cost Name"
                  v-model="manufacturingCost.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="manufacturingCost.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offest-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="manufacturingCost.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="manufacturingCost.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="manufacturingCost.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offest-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="manufacturingCost.id">
                <v-text-field
                  name="updatedBy"
                  label="Updated By"
                  v-model="manufacturingCost.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="manufacturingCost.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || saveLoading"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
  
  <script>
import { ManufacturingCostFormRules } from "../../helpers/validation-rules";
import { ManufacturingCost } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { manufacturingCostService } from "../../services/manufacturing-cost-service";
import { commonService } from "../../services/common-service";

export default {
  name: "ManufacturingCostDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    saveLoading: false,
    breadcrumbs: [
      {
        text: "Manufacturing Cost",
        disabled: false,
        to: "manufacturing-costs",
      },
      {
        text: "Manufacturing Cost Detail",
        disabled: true,
      },
    ],
    rules: new ManufacturingCostFormRules(),
    manufacturingCost: new ManufacturingCost(),
    oldManufacturingCost: new ManufacturingCost(),
    updatedDate: "",
    createdDate: "",
    responseError: "",
    statusFlag: true,
  }),
  created() {
    const id = this.$route.params.id;
    if (id != "new") {
      this.getManufacturingCostDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          this.manufacturingCost.status = this.statusFlag
            ? "ACTIVE"
            : "INACTIVE";

          manufacturingCostService
            .saveManufacturingCost(this.manufacturingCost)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    getManufacturingCostDetail(id) {
      manufacturingCostService
        .getManufacturingCostDetail(id)
        .then((res) => {
          this.manufacturingCost = res.data;
          this.createdDate = commonService.millisecondToDate(
            this.manufacturingCost.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.manufacturingCost.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.oldManufacturingCost = Object.assign({}, res.data);
          this.statusFlag =
            this.manufacturingCost.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.manufacturingCost.id) {
        this.manufacturingCost = new ManufacturingCost();
        this.statusFlag = true;
      } else {
        this.manufacturingCost = Object.assign({}, this.oldManufacturingCost);
        this.statusFlag =
          this.manufacturingCost.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/manufacturing-costs");
    },
  },
};
</script>